/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_PriceInputs */

const cs_field_price = /** @type {(inputs: Field_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cena`)
};

const en_field_price = /** @type {(inputs: Field_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price`)
};

/**
* | output |
* | --- |
* | "Price" |
*
* @param {Field_PriceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_price = /** @type {((inputs?: Field_PriceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_PriceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_price(inputs)
	return cs_field_price(inputs)
});